import SuccessLabel from './SuccessLabel';

export default SuccessLabel;
